// extracted by mini-css-extract-plugin
export default {"getOutline":"Test_getOutline__SDhnL","BottomLabel":"Test_BottomLabel__8i7tz","InfoArea":"Test_InfoArea__-axSO"};